<ion-content>
  <ion-grid class="constrained-content main-grid">
    <ion-row>
      <ion-col size="12">
        <div class="customer-create-content">
          <div class="flex-space-between flexed-align-center">
            <h1 class="card-header">Select JSM service desks to connect</h1>
            <div class="pill-tab-container">
              <ion-select
                *ngIf="connectedCredentials?.length > 1"
                [(ngModel)]="selectedCredential"
                (ionChange)="onCredentialChange()"
                interface="popover"
                style="font-size: 0.8rem; margin-right: 10px"
              >
                <ion-select-option
                  *ngFor="let credential of connectedCredentials"
                  [value]="credential"
                >
                  {{ credential.jsmInstance?.name || "Unknown Instance" }}
                </ion-select-option>
              </ion-select>
            </div>
          </div>
          <div
            class="flex-space-between"
            [hidden]="!showHelpBanner"
            style="
              background: #eafeea;
              padding: 15px;
              border-radius: 6px;
              color: #006600;
              margin-top: 15px;
              margin-bottom: 0;
              font-size: 0.8rem;
            "
          >
            <span>
              <ion-icon
                name="checkmark-outline"
                style="margin-right: 3px"
              ></ion-icon>
              Choose service desks and tickets will be synced automatically
            </span>
            <a (click)="showHelpBanner = false">
              <ion-icon name="close"></ion-icon>
            </a>
          </div>
        </div>

        <ion-card class="outline-card">
          <ng-container *ngIf="!isLoading">
            <div
              *ngIf="!connectedCredentials?.length"
              class="customer-create-content"
            >
              <div
                style="font-size: 16px; margin-bottom: 20px"
                class="admin-bar"
              >
                No JSM instances connected. Please connect a JSM instance first.
              </div>
              <ion-button
                routerLink="/dashboard/settings/jsm"
                routerDirection="root"
              >
                <ion-icon name="settings" class="padded-icon"></ion-icon>
                Go to JSM Settings
              </ion-button>
            </div>
          </ng-container>

          <ng-container *ngIf="connectedCredentials?.length">
            <div class="top-searchbar flex-space-between">
              <ion-searchbar
                mode="ios"
                placeholder="Search service desks..."
                showCancelButton="never"
                [(ngModel)]="searchText"
                (ionChange)="handleFilter()"
              ></ion-searchbar>
              <div class="flexed">
                <ion-button
                  (click)="selectAll()"
                  color="dark"
                  fill="clear"
                  class="btn-small button-dark-border"
                  [hidden]="
                    selectedServiceDesks.length > 0 &&
                    filteredServiceDesks.length === selectedServiceDesks.length
                  "
                >
                  Select all
                </ion-button>
                <ion-button
                  (click)="deselectAll()"
                  color="light"
                  class="btn-small"
                  [hidden]="
                    !selectedServiceDesks.length ||
                    selectedServiceDesks.length < filteredServiceDesks.length
                  "
                >
                  Deselect all
                </ion-button>
              </div>
            </div>
            <ion-list *ngIf="isLoadingServiceDesks">
              <ion-list-header>
                <ion-skeleton-text
                  [animated]="true"
                  style="width: 80px"
                ></ion-skeleton-text>
              </ion-list-header>
              <ion-item>
                <ion-skeleton-text
                  [animated]="true"
                  slot="start"
                  style="width: 30px"
                ></ion-skeleton-text>
                <ion-label>
                  <h3>
                    <ion-skeleton-text
                      [animated]="true"
                      style="width: 80%"
                    ></ion-skeleton-text>
                  </h3>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-skeleton-text
                  [animated]="true"
                  slot="start"
                  style="width: 30px"
                ></ion-skeleton-text>
                <ion-label>
                  <h3>
                    <ion-skeleton-text
                      [animated]="true"
                      style="width: 70%"
                    ></ion-skeleton-text>
                  </h3>
                </ion-label>
              </ion-item>
              <ion-item>
                <ion-skeleton-text
                  [animated]="true"
                  slot="start"
                  style="width: 30px"
                ></ion-skeleton-text>
                <ion-label>
                  <h3>
                    <ion-skeleton-text
                      [animated]="true"
                      style="width: 60%"
                    ></ion-skeleton-text>
                  </h3>
                </ion-label>
              </ion-item>
            </ion-list>
            <ng-container *ngIf="!isLoadingServiceDesks">
              <ngx-datatable
                class="material"
                columnMode="force"
                [headerHeight]="50"
                [footerHeight]="50"
                [rowHeight]="50"
                [scrollbarH]="true"
                [rows]="filteredServiceDesks"
                [selected]="selectedServiceDesks"
                selectionType="checkbox"
                [selectAllRowsOnPage]="false"
                [displayCheck]="false"
                [reorderable]="true"
                (select)="onSelect($event)"
              >
                <ngx-datatable-column
                  [width]="30"
                  [sortable]="false"
                  [canAutoResize]="false"
                  [draggable]="false"
                  [resizeable]="false"
                  [headerCheckboxable]="true"
                  [checkboxable]="true"
                >
                </ngx-datatable-column>
                <ngx-datatable-column name="Service Desk" prop="projectName">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <a
                      class="row-title row-link"
                      (click)="toggleRowSelected(row)"
                    >
                      {{ row.projectName }}
                    </a>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Project Key" prop="projectKey">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <ion-badge color="light">{{ row.projectKey }}</ion-badge>
                  </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Type" prop="projectTypeKey">
                  <ng-template let-row="row" ngx-datatable-cell-template>
                    <span>{{ row.projectTypeKey }}</span>
                  </ng-template>
                </ngx-datatable-column>
              </ngx-datatable>
            </ng-container>
          </ng-container>
          <div
            *ngIf="
              !isLoadingServiceDesks &&
              !isLastPage &&
              unconnectedServiceDesks.length > 0
            "
          >
            <ion-button
              size="full"
              (click)="loadServiceDesks()"
              class="no-margin"
            >
              Click to load more service desks
            </ion-button>
          </div>
        </ion-card>
      </ion-col>
    </ion-row>
    <ion-row *ngIf="!isLoading && !connectedCredentials?.length">
      <ion-col size="12" style="text-align: center; padding: 10px 0 20px 0">
        <ion-button fill="clear" (click)="goBack()"> Skip for now </ion-button>
      </ion-col>
    </ion-row>
  </ion-grid>
</ion-content>

<ion-footer
  *ngIf="connectedCredentials?.length && selectedServiceDesks?.length"
>
  <ion-toolbar
    style="
      text-align: center;
      padding: 20px;
      margin-left: auto;
      margin-right: auto;
    "
  >
    <div class="flexed" style="justify-content: center">
      <ng-container *ngIf="!authService.selectedProject">
        <ion-button
          fill="clear"
          [disabled]="true"
          color="dark"
          class="fake-button"
          >Add to:</ion-button
        >
        <ion-button
          fill="clear"
          color="dark"
          (click)="selectProject()"
          class="button-dark-border"
          style="margin-right: 5px"
        >
          <ion-icon
            [name]="project?.name ? 'custom-project' : 'custom-project-outline'"
            class="padded-icon button-icon"
          ></ion-icon>
          {{
            project?.name ? project.name : project?.id ?? "Select a project..."
          }}
          <ion-icon
            name="chevron-down-outline"
            class="icon-padded-left button-icon"
          ></ion-icon>
        </ion-button>
      </ng-container>
      <ion-button
        (click)="save()"
        color="success"
        [disabled]="isLoading || !project?.id"
      >
        Connect selected service desks
        <ion-icon
          name="arrow-forward-outline"
          class="icon-padded-left"
        ></ion-icon>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>
